import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
// import ChildPic from "../../../../../assets/images/child-round.png";
import { Link } from "react-router-dom/cjs/react-router-dom";

import { useDispatch, useSelector } from "react-redux";
// import YoutubePic from "../../../../../assets/images/youtube.png";

import useKidListFunctionality from "../../../../customHooks/kidListHook";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import useSetRules from "../useSetRules";
import RestrictedWebsiteRow from "./RestrictedWebsiteRow";
import useFirebase from "../../../../../useFirebase";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import DeleteChildInfo from "../../modals/DeleteChildInfo";
import { getMyIPAddress } from "../../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../../AxiosRtk/AddNewChild";
import { setSelectedKidId } from "../../../AxiosRtk/DashBoard";
import useLangTranslation from "../../../../customHooks/languageProvider";
import Select from "react-select";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import KidImage from "../../../../shared/KidImage/KidImage";

const RestrictedWebsite = (props) => {
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();
  const [device, setDevice] = useState("");
  const [kid, setKid] = useState(null);
  const [webUrl, setWebUrl] = useState("");

  const [error, setError] = useState("");
  const [webMonitoringData, setWebMonitoringData] = useState(null);
  const [isFormChanged, setIsFormChanged] = useState(false); // State to track if changes were made
  const { postCollectionData, getCollectionData, createCollectionData } = useFirebase();
  const history = useHistory();
  const { handleTimeSupervision } = useSetRules();
  const { getImage } = useKidListFunctionality();
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(deviceStatus, setDeviceStatus);
  const { kidList, selectedKidId, kidDevicesList } = useSelector(({ dashboard }) => dashboard);
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [showModal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState({ value: "", error: "" });
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  // const [url, setUrl] = useState(item?.websiteUrl);

  const handleGoBack = useCallback(() => {
    history.goBack();
  });

  function callFireStore(payload) {
    if (setRulesData) {
      postCollectionData(device, { webmonitoring: payload });
    } else {
      createCollectionData(device, { webmonitoring: payload });
    }

    getCollectionData(device);
    dispatch(
      setShowMessage({
        showMessage: true,
        message: "DATA_FETCH",
        defaultMessage: "Data updated successfully",
      })
    );
    setWebUrl("");
    setIsFormChanged(false); // Reset change tracking after saving
  }

  function closeModal() {
    setShowModal(false);
  }

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kid?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log("child delete catch error ==>>", err?.response?.data?.message);
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
  }

  useEffect(() => {
    if (device) {
      getDeviceStatusData(device);
    }
  }, [device]);

  useEffect(() => {
    if (props) {
      const state = props?.location?.state?.device;
      setDevice(state);
    }
  }, [props]);

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKid(kid);
    }
  }, [kidList, selectedKidId]);

  useEffect(() => {
    if (setRulesData) {
      setWebMonitoringData({ ...setRulesData?.webmonitoring });
    }
  }, [setRulesData]);

  function handleWebUrlSelect(e) {
    const { name, checked } = e.target;
    const restrictedWebsite = [...webMonitoringData?.restrictedWebsite];
    const targetWebsite = restrictedWebsite?.find(
      (item) => parseInt(item?.addUpdateTime) === parseInt(name)
    );
    const targetIndex = restrictedWebsite?.findIndex(
      (item) => parseInt(item?.addUpdateTime) === parseInt(name)
    );


    const tempObj = { ...targetWebsite };
    tempObj["isChecked"] = checked ? 1 : 0;

    restrictedWebsite?.splice(targetIndex, 1, tempObj);
    const payload = {
      ...webMonitoringData,
      restrictedWebsite,
    };
    setWebMonitoringData(payload);
    setIsFormChanged(true); // Track change
  }

  function isValidURL(url) {
    const urlPattern =
      /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
    return urlPattern.test(url);
  }

  function handleSave() {
    setError("");

    if (!webUrl) {
      setError("URL is required");
      return;
    }

    let formattedWebUrl = webUrl.trim();

    // Regular expression to check for valid domain format (without protocol)
    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // Check for valid domain (e.g., hello.com)

    // Regular expression to validate full URL (with protocol)
    const validUrlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

    // If it's a valid domain (without protocol), prepend 'https://'
    if (domainPattern.test(formattedWebUrl)) {
      // Prepend 'https://' if no protocol is found
      if (!/^https?:\/\//i.test(formattedWebUrl)) {
        formattedWebUrl = `https://${formattedWebUrl}`;
      }
    } else if (!validUrlPattern.test(formattedWebUrl)) {
      // If URL is incomplete or doesn't match domain pattern or doesn't have protocol
      setError("Invalid URL");
      return;
    }

    try {
      // Extract the hostname (in case the URL is complete, we get the hostname)
      const newHostName = new URL(formattedWebUrl).hostname;

      // Check if the website already exists in the restricted list
      const isDuplicate = webMonitoringData?.restrictedWebsite?.some(
        (item) => item?.webSiteName === newHostName
      );

      if (isDuplicate) {
        setError("This URL already exists in the restricted websites list.");
        return;
      }

      // Create the object for the restricted website
      const newTempObj = {
        addUpdateTime: Date.now(),
        blockedStatus: true,
        status: 1,
        webSiteName: newHostName,
        websiteThumbnail: null,
        websiteUrl: formattedWebUrl, // Store the URL with https://
      };

      const restrictedWebsite = [...webMonitoringData?.restrictedWebsite];
      restrictedWebsite.push(newTempObj);

      const collectionPayload = {
        ...webMonitoringData,
        restrictedWebsite: restrictedWebsite.map((item) => {
          delete item?.isChecked;
          return item;
        }),
      };

      // Call Firestore to save the data
      callFireStore(collectionPayload);
      setWebUrl(""); // Clear the input field after saving
      setIsFormChanged(false); // Reset change tracking after saving
    } catch (error) {
      setError("Invalid URL format");
      console.error(error);
    }
  }

  function handleAllSelect(e) {
    const { checked } = e.target;
    let restrictedWebsite = [...webMonitoringData?.restrictedWebsite];
    restrictedWebsite = restrictedWebsite?.map((item, index) => {
      const temp = { ...item };
      temp["isChecked"] = checked ? 1 : 0;
      return temp;
    });

    const payload = {
      ...webMonitoringData,
      restrictedWebsite,
    };

    setWebMonitoringData(payload);
    setIsFormChanged(true); // Track change
  }

  function handleDelete() {
    const itemsToBeDeleted = [...webMonitoringData?.restrictedWebsite]?.filter(
      (item) => item?.isChecked
    );

    if (itemsToBeDeleted?.length === 0) {
      return;
    }

    const itemsNotToBeDeleted = [...webMonitoringData?.restrictedWebsite]
      ?.filter((item) => !item?.isChecked)
      ?.map((item) => {
        delete item?.isChecked;
        return item;
      });

    const collectionPayload = {
      ...setRulesData?.webmonitoring,
      restrictedWebsite: itemsNotToBeDeleted,
    };

    callFireStore(collectionPayload);
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-20">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "WEB_MONITORING_RESTRICTED_WEBSITES",
                      "Restricted websites"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value == device) || ""
                  }
                  onChange={(val) => {
                    setDevice(val.value);
                  }}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex gap-4">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={webUrl}
                onChange={(e) => {
                  setWebUrl(e.target.value);
                  setIsFormChanged(true); // Mark as changed when user types
                }}
                placeholder="Enter website URL"
              />
            </div>
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleSave}
              disabled={!isFormChanged} // Disable Save button when no change is made
            >
              Save
            </button>
          </div>
          {error && (
            <div className="text-start text-danger text-capitalize my-1">
              {error}
            </div>
          )}
          <hr className="my-6" />
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-6">
            <div>
              <h5 className="text-danger text-uppercase mb-1">
                {getLangTranslation(
                  "WEB_MONITORING_BLOCKED_WEBSITED",
                  "Blocked websites"
                )}
              </h5>
              <h6 className="text-gray mb-0 fw-normal">
                {getLangTranslation(
                  "WEB_MONITORING_BLOCKED_WEBSITED_DESCRIPTION",
                  "The following websites are restricted"
                )}
              </h6>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="SELECT_ALL"
                  id="SELECT_ALL"
                  checked={
                    webMonitoringData?.restrictedWebsite?.length > 0 &&
                    webMonitoringData?.restrictedWebsite?.filter(
                      (item) => item?.isChecked !== 1
                    )?.length < 1
                  }
                  onChange={handleAllSelect}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="SELECT_ALL"
                >
                  {getLangTranslation(
                    "MANAGE_NOTIFICATION_SELECT_ALL",
                    "Select All"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={handleDelete}
              >
                {getLangTranslation(
                  "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
                  "Delete Selected"
                )}
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle" scope="col">
                    <div className="form-check">
                      {/* <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="taskName"
                      /> */}
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation("WEB_ADDRESS", "web address")}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle"></th>
                </tr>
              </thead>
              <tbody>
                {webMonitoringData?.restrictedWebsite?.map((item, index) => {
                  return (
                    <RestrictedWebsiteRow
                      item={item}
                      key={index}
                      handleWebUrlSelect={handleWebUrlSelect}
                      callFireStore={callFireStore}
                    />
                  );
                })}
              </tbody>
            </table>
            {webMonitoringData?.restrictedWebsite?.length === 0 && (
              <div className="text-center my-2 text-capitalize">
                -- {getLangTranslation("NO_DATA_LOG", "No data found")} --
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RestrictedWebsite;
